define('models/ClaimCount',[
	'core/can', 
	'models/Base', 
	'highcharts'
], function(can, Base, Highcharts) {
	
	var colors = Highcharts.getOptions().colors,
	
		ClaimCountSummary = Base.extend({
			
			findAll: function(params, success, error) {
				var me = this;
				return can.ajax({
						type: 'GET',
						url: '/Report/ClaimCountSummary',
						data: params
					})
					.then(function(data) {
						
						// Add Colors
						for (var i=0; i<data.length; i++) {
							data[i].color = colors[ i % colors.length ];
						}
						
						return me.models(data);
					})
					.then(success, error);
			}
		
		}, {
			
			//define: {
				// EntityId: {},
				// ProviderId: {},
				// IsDeleted: {},
				// StatusCode: {},
				// LocationCode: {},
				// Category: {},
				// Count: {},
				// TotalCharges: {},
				// TotalPayment: {},
				// TimeStamp: {}
			//},
			
			StatusLocation: can.compute(function() {
				return (this.attr('StatusCode')||'') +' '+ (this.attr('LocationCode')||'');
			})
			
		});
		
	ClaimCountSummary.List = ClaimCountSummary.List.extend({
		
		comparator: 'StatusCode',

		getByStatusLocation: function(statusCode, locationCode) {
			return this.filter(function(row) {
				return row.attr('StatusCode') === statusCode && row.attr('LocationCode') === locationCode;
			}).attr(0);
		},
		
		seriesData: function() {
			var series = [];
			this.each(function(row) {
		       	series.push({
					name: row.attr('StatusLocation'),
					StatusCode: row.attr('StatusCode'),
					LocationCode: row.attr('LocationCode'),
					y: row.attr('Count'),
					color: row.attr('color')
				});
			});
			return series;
		}
		
	});
	
	return ClaimCountSummary;
	
});
